/* Shared purchase contract. Shopify supplies IDs, allocations and market prices via Liquid. */
(() => {
  if (window.GrovaOffers) return;
  const validId = (value) => Number.isSafeInteger(value) && value > 0;
  const validMoney = (value) => Number.isInteger(value) && value >= 0;
  const discount = (price, compare) => compare > 0 ? Math.max(0, Math.round((compare - price) * 100 / compare)) : 0;
  const validOption = (option) => Boolean(option && validId(option.variantId) && validId(option.productId) &&
    validId(option.sellingPlanId) && [option.price, option.compareAt, option.subscriptionPrice, option.renewalPrice].every(validMoney));
  const validGift = (gift) => Boolean(gift && validId(gift.variantId) && gift.price === 0 && !gift.requiresSellingPlan);

  function read(scope = document) {
    let data;
    try { data = JSON.parse(scope.querySelector('[data-grova-offer-config]')?.textContent || '{}'); }
    catch { data = {}; }
    const options = (data.options || []).filter(validOption).map((option) => ({
      ...option,
      label: `${option.key} Month`,
      discount: `${discount(option.subscriptionPrice, option.compareAt)}% OFF`,
    }));
    const gifts = data.gifts || {};
    const giftConfigValid = ['journal', 'canister'].every((key) => validGift(gifts[key]));
    // Fixed roles in the serialized contract, not a guess based on variant order in Shopify.
    const primary = [data.options?.[0], data.options?.[3]]
      .map((raw) => options.find((option) => option.variantId === raw?.variantId && option.sellingPlanId === raw?.sellingPlanId))
      .filter(Boolean);
    return { ...data, options, primary, gifts, giftConfigValid,
      canSyncGifts: giftConfigValid && options.length === 4,
      retiredGiftIds: (data.retiredGiftIds || []).map((id) => String(id).trim()).filter(Boolean) };
  }

  function forItem(config, item) {
    if (!item) return null;
    const plan = item.selling_plan_allocation?.selling_plan?.id;
    return config.options.find((option) => String(option.variantId) === String(item.variant_id) &&
      (!plan || String(option.sellingPlanId) === String(plan))) || null;
  }

  function canBuy(config, option, subscribe = true) {
    if (!option?.available || !validId(option.variantId)) return false;
    if (!subscribe) return validMoney(option.price) && !option.requiresSellingPlan;
    return validOption(option) && (option.giftKeys || []).every((key) => validGift(config.gifts[key]) && config.gifts[key].available);
  }

  function items(config, option, subscribe = true, quantity = 1) {
    if (!canBuy(config, option, subscribe)) throw new Error('This purchase option is currently unavailable.');
    const item = { id: option.variantId, quantity };
    if (subscribe) item.selling_plan = option.sellingPlanId;
    else item.properties = { _grova_purchase_type: 'one-time', _grova_supply_months: option.key };
    return [item, ...(subscribe ? option.giftKeys : []).map((key) => ({
      id: config.gifts[key].variantId, quantity,
      properties: { _grova_free_gift: 'true', _grova_gift_source: 'subscription' },
    }))];
  }

  function desiredGifts(config, cart) {
    const desired = new Map();
    const removed = new Set(String(cart.attributes?._grova_removed_subscription_gifts || '').split(','));
    for (const item of cart.items || []) {
      if (!item.selling_plan_allocation) continue;
      const option = forItem(config, item);
      for (const key of option?.giftKeys || []) {
        const gift = config.gifts[key];
        if (!validGift(gift) || removed.has(String(gift.variantId))) continue;
        desired.set(key, (desired.get(key) || 0) + Math.max(0, Number(item.quantity) || 0));
      }
    }
    return desired;
  }
  window.GrovaOffers = { read, forItem, canBuy, items, desiredGifts, discount };
})();
